import React from "react"
import {
  Card,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TableHead,
} from "@mui/material"
import StatusBadge from "@/components/ui/badge"

interface OrderSummaryProps {
  order: {
    id: number
    note: string
    payment_method: string
    total_amount: number
    code: string
    order_date: string
    status_parsed: string
    discount_amount: number
    final_discount: number
    discount_percentage: number
    extras: {
      vat_amount: number
    }
    order_items: {}
  }
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ order }) => {
  return (
    <>
      <Card
        sx={{
          boxShadow: "none",
          borderRadius: "7px",
          mb: "25px",
          padding: { xs: "18px", sm: "20px", lg: "25px" },
        }}
        className="rmui-card"
      >
        <Box
          sx={{
            mb: "25px",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "16px", md: "18px" },
              fontWeight: 700,
            }}
            className="text-black"
          >
            Order Summary
          </Typography>
        </Box>

        <div className="mb-3">
          <span>Code: </span>
          <span className="fw-medium text-secondary mt-1">{order.code}</span>
        </div>
        <div className="mb-3">
          <span>Payment Method: </span>
          <span className="fw-medium text-secondary mt-1">
            {order.payment_method}
          </span>
        </div>
        <div className="mb-3">
          <span>Date: </span>
          <span className="fw-medium text-secondary mt-1">
            {order.order_date}
          </span>
        </div>
        {order.note && (
          <div className="mb-3">
            <span>Note: </span>
            <span className="fw-medium text-secondary mt-1">{order.note}</span>
          </div>
        )}
        <div className="mb-3">
          <span>Status: </span>
          <StatusBadge name={order.status_parsed} />
        </div>

        {/* Table */}
        <TableContainer component={Paper} className="rmui-table border">
          <Table aria-label="Table">
            <TableHead className="bg-f6f7f9">
              <TableRow>
                <TableCell
                  sx={{ padding: 0.5 }}
                  className="text-black border-bottom"
                >
                  Description
                </TableCell>

                <TableCell
                  sx={{ padding: 0.5 }}
                  className="text-black border-bottom text-end"
                >
                  Price
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell
                  sx={{ padding: 0.5 }}
                  className="text-black border-bottom"
                >
                  Discount % :
                </TableCell>

                <TableCell
                  sx={{ padding: 0.5 }}
                  className="border-bottom text-end"
                >
                  {order.discount_percentage} %
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{ padding: 0.5 }}
                  className="text-black border-bottom"
                >
                  Discount amount :
                </TableCell>

                <TableCell
                  sx={{ padding: 0.5 }}
                  className="border-bottom text-end"
                >
                  Nrs.{" "}
                  {Number(order.discount_amount) + Number(order.final_discount)}
                </TableCell>
              </TableRow>
              {/* <TableRow>
                <TableCell
                  className="text-black border-bottom"
                >
                  VAT :
                </TableCell>

                <TableCell
                  className="border-bottom text-end"
                >
                  Nrs. {order.extras?.vat_amount}
                </TableCell>
              </TableRow> */}
              <TableRow>
                <TableCell
                  sx={{ padding: 0.5 }}
                  className="text-black border-bottom"
                >
                  Grand Total :
                </TableCell>

                <TableCell
                  sx={{ padding: 0.5 }}
                  className="border-bottom text-end"
                >
                  Nrs. {order.total_amount}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </>
  )
}

export default OrderSummary
